import { useComputedColorScheme } from '@mantine/core';
import classes from './PoweredBy.module.css';

interface PoweredByProps {
  /**
   * `shell` is always on black (mono, dimmed); `surface` follows the colour scheme;
   * `stage` is always on black too but inherits the surrounding text size and colour
   * (login footer).
   */
  on: 'shell' | 'surface' | 'stage';
  prefix?: string;
  height?: number;
}

/** "Powered by" + AutoMM mark. Kept small and subordinate to Spartan / Aroo branding. */
export function PoweredBy({ on, prefix = 'Powered by', height = 10 }: PoweredByProps) {
  const scheme = useComputedColorScheme('dark');
  const mono = on !== 'surface' || scheme === 'dark';
  return (
    <span className={classes.root} data-on={on}>
      {prefix}
      <img
        src="/brand/automm-logo.png"
        alt="Automotive Mation"
        style={{ height }}
        className={mono ? classes.mono : undefined}
        data-on={on}
      />
    </span>
  );
}
